import { render, staticRenderFns } from "./Modal.component.vue?vue&type=template&id=28519292&scoped=true&lang=pug"
import script from "./Modal.component.vue?vue&type=script&lang=ts"
export * from "./Modal.component.vue?vue&type=script&lang=ts"
import style0 from "./Modal.component.vue?vue&type=style&index=0&id=28519292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28519292",
  null
  
)

export default component.exports